import { WarningAmber as WarningIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';

import { INTEGRATION_REQUEST_STATUS_LABELS } from '../../../../models/IntegrationRequest';
import type { ExistingIntegrationNotices } from '../../hooks/useExistingIntegrationNotices';
import { INTEGRATION_REQUESTS_PATH } from '../../config';

const formatDate = (value: string) => new Date(value).toLocaleDateString('es-UY');

const ExistingIntegrationAlert = ({ notices }: { notices: ExistingIntegrationNotices | null }) => {
  if (!notices) return null;
  const { openRequests, integration, webhookOverlaps } = notices;

  return (
    <div className='flex gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800'>
      <WarningIcon fontSize='small' />
      <div className='flex flex-col gap-1'>
        {openRequests.map((request) => (
          <span key={request.id}>
            Ya hay una solicitud{' '}
            <strong>{INTEGRATION_REQUEST_STATUS_LABELS[request.status] ?? request.status}</strong>{' '}
            del {formatDate(request.createdAt)} para este comercio.{' '}
            <Link className='underline' to={`${INTEGRATION_REQUESTS_PATH}/${request.id}`}>
              Ver solicitud
            </Link>
          </span>
        ))}

        {integration && (
          <>
            <span>
              <strong>Este comercio ya está integrado por API</strong>
              {integration.code ? ` (código ${integration.code})` : ''}.
            </span>
            <span>
              Servicios actuales: {integration.currentServiceCodes.join(', ') || 'ninguno'} ·
              Webhooks activos: {integration.activeWebhookCount}
            </span>
            {integration.removedServiceCodes.length > 0 && (
              <span>
                Al integrar se quitaría <strong>{integration.removedServiceCodes.join(', ')}</strong>{' '}
                de la integración actual.
              </span>
            )}
          </>
        )}

        {webhookOverlaps.map((overlap) => (
          <span key={overlap.statusName}>
            <strong>{overlap.statusName}</strong> ya notifica a {overlap.urls.join(', ')}; se va a
            sumar otro webhook.
          </span>
        ))}
      </div>
    </div>
  );
};

export default ExistingIntegrationAlert;
